export const regEmail = /^((?!\.)[\w_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm;
export const regSmallChar = /\w*[a-z]\w*/;
export const regCapitalchar = /\w*[A-Z]\w*/;
export const regNumber = /\d/;
export const regspecialChar = /[!+@#$%^&*()\-_"=+{}; :,<.>]/;